import React from 'react';

import ApiClientContext from './ApiClientContext';

function ApiClientProvider({ apiClient, children }) {
  return <ApiClientContext.Provider value={apiClient}>{children}</ApiClientContext.Provider>;
}

export default ApiClientProvider;
